/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMcpEndpointSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMcpEndpointSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMcpEndpointSecurity = {
  option1?: GetMcpEndpointSecurityOption1 | undefined;
  option2?: GetMcpEndpointSecurityOption2 | undefined;
};

export type GetMcpEndpointRequest = {
  /**
   * The ID of the MCP endpoint
   */
  id?: string | undefined;
  /**
   * The ID of the custom domain the endpoint slug is registered under. Omit to look up a platform-domain endpoint.
   */
  customDomainId?: string | undefined;
  /**
   * The slug to look up
   */
  slug?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMcpEndpointSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMcpEndpointSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMcpEndpointSecurityOption1$Outbound,
  GetMcpEndpointSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMcpEndpointSecurityOption1ToJSON(
  getMcpEndpointSecurityOption1: GetMcpEndpointSecurityOption1,
): string {
  return JSON.stringify(
    GetMcpEndpointSecurityOption1$outboundSchema.parse(
      getMcpEndpointSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMcpEndpointSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMcpEndpointSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMcpEndpointSecurityOption2$Outbound,
  GetMcpEndpointSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMcpEndpointSecurityOption2ToJSON(
  getMcpEndpointSecurityOption2: GetMcpEndpointSecurityOption2,
): string {
  return JSON.stringify(
    GetMcpEndpointSecurityOption2$outboundSchema.parse(
      getMcpEndpointSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMcpEndpointSecurity$Outbound = {
  Option1?: GetMcpEndpointSecurityOption1$Outbound | undefined;
  Option2?: GetMcpEndpointSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMcpEndpointSecurity$outboundSchema: z.ZodMiniType<
  GetMcpEndpointSecurity$Outbound,
  GetMcpEndpointSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMcpEndpointSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMcpEndpointSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMcpEndpointSecurityToJSON(
  getMcpEndpointSecurity: GetMcpEndpointSecurity,
): string {
  return JSON.stringify(
    GetMcpEndpointSecurity$outboundSchema.parse(getMcpEndpointSecurity),
  );
}

/** @internal */
export type GetMcpEndpointRequest$Outbound = {
  id?: string | undefined;
  custom_domain_id?: string | undefined;
  slug?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMcpEndpointRequest$outboundSchema: z.ZodMiniType<
  GetMcpEndpointRequest$Outbound,
  GetMcpEndpointRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    customDomainId: z.optional(z.string()),
    slug: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      customDomainId: "custom_domain_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMcpEndpointRequestToJSON(
  getMcpEndpointRequest: GetMcpEndpointRequest,
): string {
  return JSON.stringify(
    GetMcpEndpointRequest$outboundSchema.parse(getMcpEndpointRequest),
  );
}
